export default class {
    FileName = "";

	Type = "";

	File = "";

	clean = function () {
		this.FileName = "";
		this.Type = "";
		this.File = "";
	}

	IsUpload = () => { return this.File !== ""; };

	IsPdf = () => { return this.Type === 'application/pdf'; };

	IsImage = () => {
		return this.Type === 'image/jpeg' ||
			   this.Type === 'image/png';
	};
}